<template lang="pug">
  .reports.body-flex
    .toolbar.toolbar_no-padding.toolbar_margin-bottom
      .toolbar__line.toolbar__line_end
        .parameters
          e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToTable" label="Добавить")
    e-table-editable(
      ref="reports"
      :attributes="operatorReportAttr"
      :dataUrl="operatorReportUrl"
      :postUrl="operatorReportPostUrl"
      :patchUrl="garbagePatchUrl"
      :deleteUrl="garbageDeleteUrl"
      :afterFetchData="afterFetchContainerData"
      :prepareRow="prepareContainerRow"
      :tableInOnlineMode="tableInOnlineMode"
      :autoSaveAfterChange="false"
      @editEvent="editEvent"
      @afterEditRow="afterEditRow"
    )
      template(v-slot:file="{model}" v-if='!isAdd && !isEdit' )
        button.reset-btn.button(@click='downloadFile(model)') Скачать
</template>

<script>
import { tko, core } from '@/api/api-endpoints'
import year from '@/utils/year'

const Model = () => ({
  year_quarter_id: null,
  filename: null,
  file_id: null,
})

export default {
  name: 'reports',
  data() {
    return {
      isAdd: false,
      isEdit: false,
    }
  },
  computed: {
    years() {
      return year.getSpecifiedYearsOptions(2022, 2050, false)
    },
    tableInOnlineMode() {
      return this.$route.params.id
    },
    operatorReportAttr() {
      return {
        year: {
          label: 'Год',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          suggestion: {
            options: this.years,
            onSelect: this.onSelectYear,
          },
        },
        year_quarter: {
          label: 'Квартал',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          suggestion: {
            minSuggestLen: 1,
            options: this.collections.year_quarter,
            onSelect: this.onSelectQuarter,
          },
        },
        filename: {
          label: 'Наименование файла',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
        },
        file: {
          label: 'Область загрузки',
          placeholder: '',
          validationRulePattern: '(\\.*)',
          file: {
            transformFile: this.transformFile,
          },
        },
      }
    },
    operatorReportUrl() {
      return tko.operatorReport({
        query: { tko_operator_id: this.$route.params.id },
      })
    },
    fileEndpoint() {
      return tko.operatorReportDownload()
    },
    collections() {
      return (
        this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      )
    },
  },
  methods: {
    editEvent() {
      this.isEdit = true
    },
    afterEditRow() {
      this.isAdd = false
      this.isEdit = false
    },
    operatorReportPostUrl() {
      return tko.operatorReport(this.$route)
    },
    garbagePatchUrl(context, model) {
      return tko.operatorReportById(model.id)
    },
    garbageDeleteUrl(context, model) {
      return tko.operatorReportById(model.id)
    },
    addNewRowToTable() {
      this.isAdd = true
      this.$refs.reports.createRow(new Model())
    },
    afterFetchContainerData(ctx, data) {
      for (let item of data.data) {
        item.year_quarter = item.year_quarter.name
      }
      return data
    },
    prepareContainerRow(model) {
      model.tko_operator_id = this.$route.params.id
      return model
    },
    onSelectYear(ctx, $event, model) {
      model.year = $event.name
    },
    onSelectQuarter(ctx, $event, model) {
      model.year_quarter = $event.name
      model.year_quarter_id = $event.id
    },
    getCollectionEndpoint() {
      return core.collection('year_quarter')
    },
    getQuarters() {
      this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getCollectionEndpoint(),
        fromCache: true,
      })
    },
    transformFile(model) {
      if (model.file) {
        model.file_id = model.file.id
      }
    },
    downloadFile(model) {
      let a = document.createElement('a')
      if (model.file_id) {
        a.download = model.filename
        a.href = tko.operatorReportDownload(model.id)
        a.target = '_blank'
        a.click()
      }
    },
  },
  created() {
    this.getQuarters()
  },
}
</script>
